<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.156 3.59985H4.83992C4.15414 3.59985 3.59961 4.14126 3.59961 4.81063V19.1858C3.59961 19.8552 4.15414 20.3999 4.83992 20.3999H19.156C19.8418 20.3999 20.3996 19.8552 20.3996 19.1891V4.81063C20.3996 4.14126 19.8418 3.59985 19.156 3.59985ZM8.58383 17.9159H6.09008V9.89657H8.58383V17.9159ZM7.33695 8.80392C6.53633 8.80392 5.88992 8.15751 5.88992 7.36017C5.88992 6.56282 6.53633 5.91642 7.33695 5.91642C8.1343 5.91642 8.7807 6.56282 8.7807 7.36017C8.7807 8.15423 8.1343 8.80392 7.33695 8.80392ZM17.9157 17.9159H15.4252V14.0178C15.4252 13.0892 15.4088 11.8916 14.1291 11.8916C12.833 11.8916 12.6362 12.9055 12.6362 13.9522V17.9159H10.149V9.89657H12.5377V10.9925H12.5705C12.902 10.3625 13.7157 9.69642 14.9265 9.69642C17.4498 9.69642 17.9157 11.3567 17.9157 13.5158V17.9159Z"
      fill="currentColor"
    />
  </svg>
</template>
